import React from 'react'
import { Control, Controller, RegisterOptions, useForm } from 'react-hook-form'
import { isEmpty, isNil } from 'lodash'
import { RadioInput, TextInput, ToggleInput } from '@demandlocal/components'

type Props = {
  options: Array<{ label: string; value: string }>
  name: string
  label: string
  control?: Control<any>
  rules?: RegisterOptions
  icon?: JSX.Element
  type?: 'text' | 'range'
  isCollapsed?: boolean
  additionalRadios?: Array<{ label: string; value: string }>
}

const CardTextInput = ({
  options,
  name,
  label,
  control,
  type,
  icon,
  rules,
  isCollapsed = true,
  additionalRadios,
}: Props): JSX.Element => {
  const [collapsed, setCollapsed] = React.useState<boolean>(isCollapsed)

  return (
    <div className={'flex flex-col gap-5 border-2 rounded-xl p-5'}>
      <div className={'flex flex-row items-center gap-5 w-full justify-between'}>
        <div className={'font-bold flex flex-row items-center gap-5'}>
          {icon && icon}
          {label}
        </div>
        <span className={'w-1/4'}>
          <RadioInput
            name={name}
            options={[
              { label: 'Custom', value: 'custom' },
              { label: 'Any', value: 'any' },
            ]}
            onChange={() => setCollapsed(!collapsed)}
          />
        </span>
      </div>
      {/* if set to custom, expand to following: */}
      {!collapsed && (
        <div className={'flex flex-row gap-5'}>
          {options?.map(({ label, value }, index, array) => {
            const isLast = index === array.length - 1
            return (
              <Controller
                key={value}
                name={name}
                control={control}
                rules={rules}
                render={({ field, fieldState: { error } }) => {
                  const fieldValue =
                    typeof field?.value === 'object' ? field?.value?.value : field?.value
                  const parsedFieldValue =
                    isNil(fieldValue) || fieldValue?.toString()?.length === 0
                      ? undefined
                      : fieldValue
                  return (
                    <div className="w-full">
                      <TextInput inverted name={value} label={label} />
                    </div>
                  )
                }}
              />
            )
          })}
        </div>
      )}

      {!collapsed &&
        additionalRadios &&
        additionalRadios.map(({ label, value }, index, arr) => {
          return (
            <Controller
              name={name}
              key={value}
              control={control}
              rules={rules}
              render={({ field, fieldState: { error } }) => {
                const fieldValue =
                  typeof field?.value === 'object' ? field?.value?.value : field?.value
                const parsedFieldValue =
                  isNil(fieldValue) || fieldValue?.toString()?.length === 0
                    ? undefined
                    : fieldValue
                return (
                  <div
                    className={`flex justify-between ${
                      index === 0 ? 'border-t-2' : ''
                    } pt-3`}>
                    <div className={'font-bold text-sm text-primary-xiketic'}>
                      {label}
                    </div>
                    <ToggleInput name={value} label={''} />
                  </div>
                )
              }}
            />
          )
        })}
    </div>
  )
}

export default CardTextInput
